import http, { handleHttpError, handleHttpResponse } from '../../../services/http'
import { HTTPResponse } from '../../../services/http/http.types.ts'
import {
  IMaintenanceBlankSchema,
  IMaintenanceProcess,
  TCreateMaintenanceBlankDTO,
  TCreateMaintenanceProcessDTO,
} from './maintenance.types.ts'

const getBlankSchemas = async (): Promise<HTTPResponse<IMaintenanceBlankSchema[]>> => {
  return http.get('/nsi/v1/mdm/maintenance/blank-schemas').then(handleHttpResponse).catch(handleHttpError)
}

const createBlankSchema = async (dto: TCreateMaintenanceBlankDTO): Promise<HTTPResponse<IMaintenanceBlankSchema>> => {
  return http.post('/nsi/v1/mdm/maintenance/blank-schemas', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateBlankSchema = async (
  id: IMaintenanceBlankSchema['id'],
  updates: Partial<IMaintenanceBlankSchema>
): Promise<HTTPResponse<IMaintenanceBlankSchema>> => {
  return http
    .patch(`/nsi/v1/mdm/maintenance/blank-schemas/${id}`, updates)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteBlankSchema = async (id: IMaintenanceBlankSchema['id']): Promise<HTTPResponse<IMaintenanceBlankSchema>> => {
  return http.delete(`/nsi/v1/mdm/maintenance/blank-schemas/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const getMaintenanceProcesses = async (): Promise<HTTPResponse<IMaintenanceProcess[]>> => {
  return http.get('/nsi/v1/mdm/maintenance/processes').then(handleHttpResponse).catch(handleHttpError)
}

const createMaintenanceProcess = async (
  dto: TCreateMaintenanceProcessDTO
): Promise<HTTPResponse<IMaintenanceProcess>> => {
  return http.post('/nsi/v1/mdm/maintenance/processes', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateMaintenanceProcess = async (
  id: IMaintenanceProcess['id'],
  updates: TCreateMaintenanceProcessDTO
): Promise<HTTPResponse<IMaintenanceProcess>> => {
  return http.patch(`/nsi/v1/mdm/maintenance/processes/${id}`, updates).then(handleHttpResponse).catch(handleHttpError)
}

const deleteMaintenanceProcess = async (id: IMaintenanceProcess['id']): Promise<HTTPResponse<IMaintenanceProcess>> => {
  return http.delete(`/nsi/v1/mdm/maintenance/processes/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const maintenanceApi = {
  getBlankSchemas,
  createBlankSchema,
  updateBlankSchema,
  deleteBlankSchema,
  getMaintenanceProcesses,
  createMaintenanceProcess,
  updateMaintenanceProcess,
  deleteMaintenanceProcess,
}
export default maintenanceApi
